export enum SignInMethod {
    AccessToken = 'AccessToken',
    Credentials = 'Credentials',
    SignInToken = 'SignInToken',
}
